import axios from 'axios';
import { getCSRFToken } from './csrf';

// Configure axios defaults for CSRF authentication
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-CSRFToken'] = getCSRFToken();

// API base configuration
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://108.175.2.100:8081';
// const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';


// Create axios instance with base configuration
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-CSRFToken': getCSRFToken(),
  },
});

// Add request interceptor to refresh CSRF token on each request
apiClient.interceptors.request.use(
  (config) => {
    config.headers['X-CSRFToken'] = getCSRFToken();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default apiClient; 